export default __webpack_public_path__ + "static/media/salonGroupBackground.0aebb151.png";